export const ROUTES = {
  CONTACTS: '/contacts',
  CONTACTS_EDIT: '/contacts/:id/edit',
  CONTACTS_DETAIL: '/contacts/:id/detail',
  CONTACTS_CREATE: '/contacts/create',
  CONTACTS_IMPORT: '/contacts/import',
};
